<template>
  <div class="xiaobu-container" v-closeSelect="'window'">
    <step class="step-box" :active="active" :stepList="stepList"></step>
    <first-box ref="firstBoxRef" @next="handleNext" :detailInfo="detailInfo" v-show="active === 1"
      :unEditSku="unEditSku" :isReadOnly="isReadOnly" @categoryChange="handleCategoryChange"></first-box>
    <second-box ref="secondBoxRef" @pre="active--" @next="handleNext" :detailInfo="detailInfo" v-show="active === 2"
      :isReadOnly="isReadOnly"></second-box>
    <third-box ref="thirdBoxRef" @pre="active--" @next="handleNext" :detailInfo="detailInfo" v-show="active === 3"
      :isReadOnly="isReadOnly" :unEditSku="unEditSku"></third-box>
    <fourth-box @pre="active--" @next="handleNext" :detailInfo="detailInfo" v-show="active === 4"
      :isReadOnly="isReadOnly"></fourth-box>
    <div class="right-box">
      <div class="show-btn flex-c-c">
        <i class="left-icon el-icon-d-arrow-left"></i>
        <i class="right-icon el-icon-d-arrow-right"></i>
      </div>
      <div class="control-btn flex-col">
        <div class="btn-box" v-if="type !== 'add'">
          <div class="btn flex-c-c flex-col" @click="handleEditChange">
            <i class="el-icon-edit"></i>
            <span class="text">{{ !isReadOnly ? "取消编辑" : "编辑" }}</span>
          </div>
        </div>
        <div class="btn-box" @click="handleBack">
          <div class="btn flex-c-c flex-col">
            <i class="el-icon-back"></i>
            <span class="text">返回</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { commonApi, goodsApi } from "@/api"
import Step from "@/components/step"
import FirstBox from "./components/first-box/index.vue"
import SecondBox from "./components/second-box/index.vue"
import ThirdBox from "./components/third-box/index.vue"
import FourthBox from "./components/fourth-box/index.vue"
export default {
  name: "productPublishGoods",
  components: {
    Step,
    FirstBox,
    SecondBox,
    ThirdBox,
    FourthBox
  },
  data() {
    return {
      oldDataArr: [], // 旧的数据列表  保质期  保质期预警  库存预警
      newDataArr: [], // 新的 数据列表  保质期  保质期预警  库存预警
      unEditSku: false, // 是否不可编辑商品规格及属性 当该商品已入库后不能修改规格
      type: "", //
      isReadOnly: false, // 是否只读
      active: 1,
      stepList: [
        {
          content: "基本信息"
        },
        {
          content: "参数配置"
        },
        {
          content: "规格配置"
        },
        {
          content: "详细介绍"
        }
      ],
      submitForm: {
        goodsImgsList: [],
        deleteFiles: []
      },
      oldGoodImgList: [], // 老的商品图片列表 用于比对 从而在服务器中删除被删除的图片
      deleteImgList: [], // 被删除的商品图片列表
      detailInfo: {}
    }
  },
  created() {
    this.setTagTitleAndBreadcrumb()
    const { query } = this.$route
    this.type = query.type
    if (query.type === "look") {
      this.isReadOnly = true
    } else {
      this.isReadOnly = false
    }
    if (query.goodsId) {
      // 编辑商品
      goodsApi.getDetailById({ id: query.goodsId }).then(data => {
        this.detailInfo = data
        // 记录旧的保质期 和 保质期预警 库存预警
        this.oldDataArr = [this.detailInfo.qualityGuaranteePeriod, this.detailInfo.qualityGuaranteePeriodWarning]
        const spuTable = JSON.parse(this.detailInfo.spuTable)
        for (let i = 0; i < spuTable.length; i++) {
          this.oldDataArr.push(spuTable[i].inVentoryAlertNum)
        }
        // 记录旧图片
        this.oldGoodImgList = data.goodsImgs.split(",")
      })

      // 获取是否可以编辑 规格及属性
      goodsApi.getControlByGoodsId({ goodsId: query.goodsId }).then(data => {
        this.unEditSku = data.result
      })
    }
  },
  methods: {
    // 编辑不可编辑改变事件
    handleEditChange() {
      this.isReadOnly = !this.isReadOnly
      // 面包屑和 tags 栏
      this.setTagTitleAndBreadcrumb(true)
    },
    // 分类改变事件
    handleCategoryChange(data) {
      this.$refs.secondBoxRef && this.$refs.secondBoxRef.setParams(data)
      this.$refs.thirdBoxRef && this.$refs.thirdBoxRef.setCategoryId(data.categoryId)
    },
    // 返回
    handleBack() {
      this.$store.dispatch("tagsView/delView", this.$route).then(() => {
        if (this.mixinHasPermi(["product:goods:list"])) {
          this.$router.push({ name: "productGoodsManage" })
        } else {
          this.$router.push("/")
        }
      })
    },
    // 上传照片
    handleUploadImg() {
      return new Promise((resolve, reject) => {
        const goodsImgsList = []
        let num = 0
        for (let i = 0; i < this.submitForm.goodsImgsList.length; i++) {
          const item = this.submitForm.goodsImgsList[i]
          if (item.raw) {
            num++
            const formData = new FormData()
            formData.append("file", item.raw, item.name)
            commonApi.upload(formData).then(res => {
              goodsImgsList.push({
                url: res.url,
                order: i
              })
              if (res.IS_COMPLETE) {
                console.log("全部照片上传完毕")
                // 对 goodsImgsList 按 order 排序
                goodsImgsList.sort((a, b) => a.order - b.order)

                const resultList = goodsImgsList.map(item => {
                  return item.url
                })
                resolve(resultList)
              }
            })
          } else if (item.url) {
            goodsImgsList.push({
              url: item.url,
              order: i
            })
          }
        }
        if (num === 0) {
          const resultList = goodsImgsList.map(item => {
            return item.url
          })
          resolve(resultList)
        }
      })
    },
    // 判断两个数组是否完全一致
    arraysAreEqual(arr1, arr2) {
      if (arr1.length !== arr2.length) {
        return false
      }
      for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
          return false
        }
      }
      return true
    },
    // 下一步
    async handleNext(form) {
      this.submitForm = Object.assign(this.submitForm, form)
      if (this.active !== 4) {
        if (this.active === 2) {
          this.$refs.thirdBoxRef && this.$refs.thirdBoxRef.setGoodsSn(this.submitForm.goodsSn)
        }
        this.active++
        return
      }
      // 上传照片
      const goodsImgsList = await this.handleUploadImg()
      // 比对 老图片中被删除的图片 
      const deleteImgList = this.oldGoodImgList.filter(item => {
        return !goodsImgsList.includes(item)
      })
      // 被删除的图片数组
      this.deleteImgList = deleteImgList
      this.submitForm.goodsImgsListStr = goodsImgsList.join(",")
      this.submitForm.deleteFiles = this.submitForm.deleteFiles.concat(this.deleteImgList)
      const params = JSON.parse(JSON.stringify(this.submitForm))
      params.goodsImgs = params.goodsImgsListStr
      delete params.goodsImgsListStr

      // 规格数据
      params.skuInfo = JSON.stringify(params.skuInfo)
      if (!params.goodsId) {
        goodsApi.createItem(params).then(res => {
          this.$modal.msgSuccess("保存成功")
          this.$store.dispatch("tagsView/delView", this.$route).then(() => {
            this.$router.push({ name: "productGoodsManage" })
          })
        })
      } else {
        let notChangeWarning = true // true 表示没改变预警的数据 false 则表示有改动
        // 记录新的保质期 和 保质期预警 库存预警
        this.newDataArr = [params.qualityGuaranteePeriod, params.qualityGuaranteePeriodWarning]
        const spuTable = params.spuTable
        for (let i = 0; i < spuTable.length; i++) {
          this.newDataArr.push(spuTable[i].inVentoryAlertNum)
        }
        notChangeWarning = this.arraysAreEqual(this.oldDataArr, this.newDataArr)

        goodsApi.updateItem(params).then(res => {
          if (!notChangeWarning) { // 有改动 已入库 的 有修改保质期 保质期预警 库存预警的 获取用户信息更新角标
            this.$store.dispatch("user/getUserInfo")
          }
          this.$modal.msgSuccess("修改商品成功")
          this.$store.dispatch("tagsView/delView", this.$route).then(() => {
            this.$router.push({ name: "productGoodsManage" })
          })
        })
      }
    },
    // 设置标签名和面包屑名
    setTagTitleAndBreadcrumb(judgeByIsReadOnly) {
      this.$nextTick(() => {
        setTimeout(() => {
          const { query } = this.$route
          const params = { fullPath: this.$route.fullPath, title: "" }
          if (query.goodsId) {
            const obj = {
              "edit": "编辑商品",
              "look": "查看商品",
              "add": "发布商品"
            }
            const str = this.isReadOnly ? "查看商品" : "编辑商品"
            params.title = judgeByIsReadOnly ? str : obj[query.type] || "发布商品"
          } else {
            params.title = "发布商品"
          }
          this.$store.commit("tagsView/SET_TAG_TITLE_BY_FULL_PATH", params)
          // 通知面包屑修改面包屑
          this.$bus.$emit("setBreadcrumbByFullPath", params)
        }, 0)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.xiaobu-container {
  .step-box {
    background: #fff;
    padding: 24px;
    border-radius: 4px;
  }

  .right-box {
    position: fixed;
    right: 0;
    bottom: 200px;
    cursor: pointer;
    transition: all 0.72s;
    z-index: 9;

    &:hover {
      right: 88px;

      .show-btn {
        .left-icon {
          display: none;
        }

        .right-icon {
          display: block;
        }
      }
    }

    .show-btn {
      width: 20px;
      height: 40px;
      background: #ffffff;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
      box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);

      .left-icon {
        display: block;
      }

      .right-icon {
        display: none;
      }
    }

    .control-btn {
      position: absolute;
      left: 20px;
      top: 50%;
      background-color: #FFFFFF;
      transform: translateY(-50%);
      border-radius: 10px;
      box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);

      .btn-box {
        width: 76px;
        height: 76px;
        text-align: center;
        border-radius: 4px;
        padding: 8px;

        &:not(:last-child) {
          border-bottom: 1px solid rgba(5, 5, 5, 0.06);
        }

        .btn {
          width: 100%;
          height: 100%;
          border-radius: 10px;

          .text {
            line-height: 16px;
            margin-top: 8px;
            font-size: 12px;
          }

          &:hover {
            background-color: rgba(0, 0, 0, 0.06);
            background-color: #008CFF;
            color: #fff;
          }
        }
      }
    }
  }

  ::v-deep .control-box {
    width: 100%;
    height: 94px;
    border: solid 1px #e6ebf5;
    border-radius: 4px;
    margin-top: 18px;
    background-color: #fff;

    .el-button {
      width: 128px;
      height: 41px;
      font-size: 16px;

      &.el-button--success {
        border-style: dashed;
      }
    }
  }
}
</style>
